import { render } from "./PersonalDataEmailPhoneForm.vue?vue&type=template&id=2179e9af&ts=true"
import script from "./PersonalDataEmailPhoneForm.vue?vue&type=script&lang=ts"
export * from "./PersonalDataEmailPhoneForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__